import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import { UgResumido } from "@/types/administracao/ug/ug-resumido";
import { UG } from "@/types/administracao/ug/ug";

const ugService = {
  buscarUG,
  buscarUGsAtivas,
  cadastrarGestor,
  excluirGestor,
  listarUGs,
  ListarUGsGeridas,
  obterUGgestor,
  obterUgsUsuario,
  obterUgsAtivas,
  getAllUnidadeGestora,
  inativarUg,
  reativarUg,
  getUgById,
  createUg,
  editUg,
  getAllNaturezaJuridica,
  getAllPoderes,
  getAllTiposUgs,
  getAllEsferas,
  getAllUgsSuperiores,
};

async function buscarUG(): Promise<UnidadeGestoraResumida> {
  const response = await Service.$http.get(
    process.env.VUE_APP_API_USUARIOS + "crp-unidade-gestora/minha-ug"
  );
  if (response) return new UnidadeGestoraResumida(response.data)
  throw new PortalError("Falha ao buscar UG");
}

async function obterUgsUsuario() {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_USERS_API + "/usuarios/Ugs"
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function obterUgsAtivas() {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_USERS_API + "/usuarios/ugsAtivas"
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function buscarUGsAtivas(): Promise<UnidadeGestoraResumida[]> {
  const url = `${process.env.VUE_APP_API_USUARIOS}pcm-unidade-gestora/ugs-ativas`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200)
    return response.data.map((ug: any) => new UnidadeGestoraResumida(ug));
  throw new PortalError("Falha ao buscar UGs ativas");
}


//Api nova
//lista todas as UGs disponíveis
async function listarUGs(perPage: number, page: number): Promise<UnidadeGestoraResumida[]> {
  const response = await Service.$http.get(`${process.env.VUE_APP_API_USUARIOS}crp-unidade-gestora?page=${page}&perPage=${perPage}`)
  if (response && response.status === 200) return response.data.data.map((ug: any) => new UnidadeGestoraResumida(ug))
  else throw new PortalError("Falha ao tentar listar UGs")
}

//lista UGs que são geridas por um usuário específico
async function ListarUGsGeridas(cpf: string): Promise<UnidadeGestoraResumida[]> {
  const response = await Service.$http.get(`${process.env.VUE_APP_API_USUARIOS}crp-unidade-gestora/buscarPorGestor/${cpf}`)
  if (response && response.status === 200) return response.data.map((ug: any) => new UnidadeGestoraResumida(ug))
  else throw new PortalError("Falha ao tentar listar UGs geridas por este usuário")
}

//Cadastrar/substituir um gestor específico a uma UG específica
async function cadastrarGestor(idUG: number, idUsuario: number) {
  const url = `${process.env.VUE_APP_API_USUARIOS}crp-unidade-gestora/cadastrarGestor/${idUG}/${idUsuario}`
  const response = await Service.$http.patch(url)
  if (response && response.status === 200) return response
  else throw new PortalError("Falha ao cadastrar gestor(a).")
}

//Obter ug com gestor
async function obterUGgestor(codigo: string): Promise<UnidadeGestoraResumida> {
  const response = await Service.$http.get(`${process.env.VUE_APP_API_USUARIOS}crp-unidade-gestora/${codigo}`)
  if (response && response.status === 200) return new UnidadeGestoraResumida(response.data)
  else throw new PortalError("Falha ao obter Unidade Gestora com gestor.")
}

//Excluir gestor de uma UG específica
async function excluirGestor(idUG: number) {
  const response = await Service.$http.patch(`${process.env.VUE_APP_API_USUARIOS}crp-unidade-gestora/removerGestor/${idUG}`)
  if (response && response.status === 200) return response
  throw new PortalError("Falha ao remover gestor(a).");
}

async function getAllUnidadeGestora(pagina: number, nome: string | null, municipio: number | null): Promise<{ ugs: UgResumido[], totalRows: number }> {
  try {
    const response = await Service.$http.get(
      `${process.env.VUE_APP_USERS_API}/UnidadeGestora/filtrar?pageSize=10&page=${pagina}${nome ? `&nome=${nome}` : ""}${municipio ? `&municipio=${municipio}` : ""}`
    )
    const totalRows = response.data.totalRows
    const ugs = response.data.ugs.map((ug: any) => new UgResumido(ug))
    return { ugs, totalRows }
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function inativarUg(idUg: number): Promise<any> {
  try {
    const response = await Service.$http.delete(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/inativar/${idUg}`)
    return response
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function reativarUg(idUg: number): Promise<any> {
  try {
    const response = await Service.$http.patch(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/reativar/${idUg}`)
    return response
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getUgById(idUg: number): Promise<UG> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/detalhes/${idUg}`)
    return new UG(response.data)
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function createUg(ug: UG): Promise<UG> {
  try {
    const response = await Service.$http.post(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/adicionar`, ug)
    return new UG(response.data)
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function editUg(ug: UG): Promise<UG> {
  try {
    const response = await Service.$http.patch(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/editar/${ug.id}`, ug)
    return new UG(response.data)
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getAllNaturezaJuridica(): Promise<{ IdNaturezaJuridica: number, NmNome: string }[]> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/naturezaJuridica/listar`)
    return response.data
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getAllPoderes(): Promise<{ IdPoder: number, NmNome: string }[]> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/poder/listar`)
    return response.data
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getAllTiposUgs(): Promise<{ IdTipoUnidadeGestora: number, NmNome: string }[]> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/tipoUg/listar`)
    return response.data
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getAllEsferas(): Promise<{ IdEsfera: number, NmNome: string }[]> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/esfera/listar`)
    return response.data
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

async function getAllUgsSuperiores(idEsfera = 0, idMunicipio = 0): Promise<{ Id: number, NmNome: string }[]> {
  try {
    const response = await Service.$http.get(`${process.env.VUE_APP_USERS_API}/UnidadeGestora/unidadeGestora/listar?idEsfera=${idEsfera}&idMunicipio=${idMunicipio}`)
    return response.data
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors)
        for (const [key, value] of Object.entries(e.response.data.errors))
          errors.push(`${key}: ${value}`);
      throw new PortalError(
        e.response.data.erros ?? e.response.data.msg ?? errors
      );
    } else throw e;
  }
}

export default ugService;
